import { getHomeElementsByBucket } from './chunk-B5YSX73X.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import { isEqual } from 'lodash';

var generatePositions = (hotButtonsArray, pageIndex) => {
  return hotButtonsArray.map((newItem, index) => {
    const newPosition = index + 1 + pageIndex * 10;
    return __spreadProps(__spreadValues({}, newItem), {
      position: newPosition
    });
  });
};
var getIsSaveButtonEnabledCore = (state, organizationId) => {
  const lastRearrangePreview = state.menu.lastRearrangePreview;
  const previewElements = state.menu.previewElements;
  const currentMenuTypeId = state.register.registerNavigation.menuTypeId;
  const currentMenuTypes = state.menu.selectedMode.currentMenu.menuTypes;
  const currentMenuType = currentMenuTypes[currentMenuTypeId];
  const oldHotButtons = currentMenuType.hotButtons;
  const newHotButtons = getNewHotButtonsCore(state, organizationId);
  const lastSaved = getHomeElementsByBucket(currentMenuType.homeScreenElements);
  const hotButtonsAreEqual = isEqual(oldHotButtons, newHotButtons);
  const homePreviewAreEqual = isEqual(previewElements, lastSaved);
  return lastRearrangePreview.categories.length > 0 || lastRearrangePreview.subcategories.length > 0 || lastRearrangePreview.items.length > 0 || lastRearrangePreview.combos.length > 0 || lastRearrangePreview.itemGroups.length > 0 || lastRearrangePreview.comboItems.length > 0 || lastRearrangePreview.modifierTags.length > 0 || lastRearrangePreview.modifierGroups.length > 0 || lastRearrangePreview.modifierItems.length > 0 || lastRearrangePreview.general.length > 0 || !hotButtonsAreEqual || !homePreviewAreEqual;
};
var getNewHotButtonsCore = (state, organizationId) => {
  const lastRearrangePreview = state.menu.lastRearrangePreview;
  const locationId = state.menu.selectedMode.id;
  const hotButtonsArray = lastRearrangePreview.hotButtons.flat(1);
  return hotButtonsArray.filter(
    (hotButton) => hotButton.type !== "none" /* NONE */ || hotButton.wasDeleted
  ).reduce((acc, hotButton) => {
    var _a, _b, _c, _d;
    if (((_b = (_a = hotButton == null ? void 0 : hotButton.id) == null ? void 0 : _a.toString()) == null ? void 0 : _b.includes("-")) && hotButton.wasDeleted)
      return acc;
    else if (!((_d = (_c = hotButton == null ? void 0 : hotButton.id) == null ? void 0 : _c.toString()) == null ? void 0 : _d.includes("-")) && hotButton.wasDeleted)
      return __spreadProps(__spreadValues({}, acc), {
        [hotButton.id]: null
      });
    const newElement = {
      id: hotButton.id,
      type: hotButton.type,
      bucketId: hotButton.bucketId,
      position: hotButton.position,
      textColor: hotButton.textColor,
      backgroundColor: hotButton.backgroundColor,
      menuTypeID: hotButton.menuTypeID,
      organizationId,
      locationId
    };
    if (hotButton.id.toString().includes("-"))
      delete newElement.id;
    return __spreadProps(__spreadValues({}, acc), {
      [hotButton.id]: newElement
    });
  }, {});
};

export { generatePositions, getIsSaveButtonEnabledCore, getNewHotButtonsCore };
